import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { ContestGraph, PrizeModal } from './';
import getOrdinal from './util/getOrginal';
import queryParamsToObj from './util/queryParamsToObj';

export class ActiveContests extends Component {

  state = {
    contestEventResults: {},
    message: '',
    isModalOpen: false,
    contestEventPrizePayouts: [],
    getCount: true,
    startTimer: false
  }
  componentDidMount = () => {
    let { countdown } = queryParamsToObj();
    // QA can use countdown in url params to emulate their own countdown to test
    if(countdown) this.setState({ testCountdown: countdown })

    const { actions: { fetchContestEventResults }, contestEventId } = this.props;

    fetchContestEventResults(contestEventId);
  }
  
  componentDidUpdate = (prevProps) => {
    const {
      props: { contests: { contestEventResults, contestEventAgents }, contestEventId },
      state: { startTimer, getCount, testCountdown }
    } = this;

    const contestResults = contestEventResults['contestEventResults-'+contestEventId];
    const prevContestResults = prevProps.contests.contestEventResults['contestEventResults-'+contestEventId];

    if(contestResults && prevContestResults !== contestResults) {
      this.setState({ 
        contestEventResults: contestResults,
        startTimer: true
      })
    }

    if(contestEventResults && contestEventAgents && Object.keys(contestEventResults).length >= contestEventAgents.length && startTimer && getCount) {

      let count = contestResults.remainingDateTime;
      // use below to test
      // count = '00.00:00:05'
      if(testCountdown) count = testCountdown;

      if(count === '0.00:00:00') this.setState({ count: 'Contest Complete' })
      else this.setCountdown(count)

      this.setState({ getCount: false})
    }
  }

  componentWillUnmount = () => {
    clearInterval(this.inter);
  }

  setCountdown = (count) => {
    const splitCount = count.split('.');
    let days = parseInt(splitCount[0], 10);
    let hour = parseInt(splitCount[1].split(':')[0], 10);
    let min = parseInt(splitCount[1].split(':')[1], 10);
    let sec = parseInt(splitCount[1].split(':')[2], 10);

    this.inter = setInterval(() => {
      const contestEnded = sec === 1 && min === 0 && hour === 0 && days === 0;

      if (contestEnded) {
        clearInterval(this.inter);
        this.setState({ count: 'Contest Complete' }); 
      }

      if(days === -1) {
        days = 0; hour = 23; min = 59; sec = 60;
      }

      if(hour !== 0 && min === 0 && sec === 0) hour--;

      if(days === 1 && hour === 0 && min === 0 && sec === 0) {
        days--; hour = 23; min = 60; sec = 60;
      }

      sec === 0 ? sec = 59 : sec--;

      if(sec === 59) {
        min--;

        if(min < 0) min = 59;
      }

      if(min === 60) min--;
      
      if(!contestEnded) {
        if(days > 0 || days === -1) {
          this.setState({count: (
            <Fragment>
              <div> {days === -1 ? 1 : days} <span> {days === -1 || days === 1 ? 'day' : 'days'} remaining</span></div>
            </Fragment>
          )});
        }

        else if(days === 0 && hour === 0 && min === 0 && sec > 0) this.setState({count: (
          <div>{sec}<span> seconds remaining</span></div>
        )});

        else if(hour < 1 && min > 0) {
          this.setState({count: (
            <Fragment>
              { min !== 0 && <div>{min}<span> min remaining</span></div> }
            </Fragment>
          )});

        } else {
          this.setState({count: (
            <Fragment>
              <div>{hour}<span> hrs { min === 0 && ' remaining'}</span></div>
              { min !== 0 && <div>{min}<span> min remaining</span></div> }
            </Fragment>
          )});
        }
      }
    }, 1000);
  }

  toggleModal = async () => {
    const {
      props: { contestEventId, actions: { fetchContestEventPrizePayouts } },
      state: { isModalOpen }
    } = this;

    if(isModalOpen) {
      this.setState({ fadeCFModal: false })
      setTimeout(() => {
        this.setState({ isModalOpen: false })
      }, 500)
    } else {
      await fetchContestEventPrizePayouts(contestEventId, contestEventId);

      this.setState({ isModalOpen: true })
      setTimeout(() => {
        this.setState({ fadeCFModal: true })
      }, 500)
    }
  }

  render() {
    const {
      props: {
        contestName,
        contestQualifier,
        contestEndTime,
        contestEventId,
        common,
        contestQualifierType,
        contests: { contestEventResults: contestEventResultsFromProps, contestEventAgents }
      },
      state: {
        count,
        isModalOpen,
        fadeCFModal,
        contestEventResults,
        contestEventResults: { 
          currentRank,
          numberOfContestants,
          items
        }
      }
    } = this;

    const hasContestData = contestEventResults && contestEventResultsFromProps && 
    contestEventAgents && Object.keys(contestEventResults).length > 0 && 
    Object.keys(contestEventResultsFromProps).length >= contestEventAgents.length && count

    return (
      <Fragment >
        { hasContestData ?
          <div className="ActiveContests__wrap">
            <div className="ActiveContests__title-wrap" onClick={ this.toggleModal }>
              <div className="ActiveContests__title">
                { contestName } { contestEventId }
              </div>
              <div className="ActiveContests__title-info">
                i
              </div>
            </div>
            <div className="ActiveContests__subtitle">
              <div className="ActiveContests__subtitle-wrap">
                <div>
                  <div className="ActiveContests__subtitle-title">
                    RANKING
                  </div>
                  <div className="ActiveContests__subtitle-value">
                    { currentRank ? currentRank + getOrdinal(currentRank) + ' Place' : 'N/A' }
                  </div>
                  <div className="ActiveContests__subtitle-text">
                    Out of { numberOfContestants !== 0 ? numberOfContestants : 'N/A' }
                  </div>
                </div>
              </div>
              <div className="ActiveContests__subtitle-wrap">
                <div>
                  <div className="ActiveContests__subtitle-title">
                    COUNTDOWN
                  </div>
                  <div className="ActiveContests__subtitle-value">
                    { count }
                  </div>
                  <div className="ActiveContests__subtitle-text">
                    Ends { contestEndTime }
                  </div>
                </div>
              </div>
              <div className="ActiveContests__subtitle-wrap">
                <div>
                  <div className="ActiveContests__subtitle-title">
                    QUALIFIER
                  </div>
                  <div className="ActiveContests__subtitle-value">
                    { contestQualifier + ' ' }
                    { contestQualifier === 1 ? contestQualifierType.slice(0,-1).toLowerCase() : contestQualifierType.toLowerCase() }
                  </div>
                  <div className="ActiveContests__subtitle-text">
                    Minimum to earn prize
                  </div>
                </div>
              </div>
            </div>

            <ContestGraph 
              graphData={ items }
              user={ common.user }
            />

            { isModalOpen &&
              <PrizeModal
                closeModal={ this.toggleModal }
                isModalOpen={ isModalOpen }
                contestEndTime={ contestEndTime }
                contestEventResults={ contestEventResults }
                contestEventId={ contestEventId }
                fadeCFModal={ fadeCFModal }
              />
            }
          </div>
          :
          <Fragment>
            <div className='ActiveContests-loader'>
              <div className='ActiveContests-loader__overlay'>
                <div className='ActiveContests-loader__wrap'>
                  <div className='ActiveContests-loader__bars'>
                    <span></span><span></span><span></span><span></span><span></span>
                  </div>
                  <h6 className='ActiveContests-loader__text'>Loading...</h6>
                </div>
              </div>
            </div>
            <div className="ActiveContest__shell"></div>
          </Fragment>
        }
      </Fragment>
    );
  }
}
/* istanbul ignore next */
const mapStateToProps = ({ contests, common }) => ({ contests, common })
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({ actions: bindActionCreators({ ...actions }, dispatch)});

export default connect(mapStateToProps, mapDispatchToProps)(ActiveContests);


// WEBPACK FOOTER //
// ./src/features/contests/ActiveContests.js